import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <h5 className="footer-header">&copy;Copyrights 2023</h5>
    </div>
  );
};

export default Footer;
